/* eslint-disable jira/filename-case */
// Issue Type Templates
import {
	DESCRIPTION_TYPE,
	ENVIRONMENT_TYPE,
	TEXT_AREA_CF_TYPE as TEXT_AREA_CF_TYPE_ORIGINAL,
} from '@atlassian/jira-platform-field-config/src/index.tsx';

export const TASK = 'task' as const;
export const BUG = 'bug' as const;
export const STORY = 'story' as const;
export const EPIC = 'epic' as const;
export const SUB_TASK = 'subtask' as const;
export const CUSTOM = 'custom' as const;

export type TemplateId = typeof TASK | typeof BUG | typeof STORY | typeof EPIC | typeof SUB_TASK;

export const TEMPLATES_WHITELIST: readonly ['task', 'bug', 'story', 'epic'] = [
	TASK,
	BUG,
	STORY,
	EPIC,
] as const;
export const TEXT_AREA_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea' =
	TEXT_AREA_CF_TYPE_ORIGINAL;
export const DESCRIPTION_FIELD_TYPE: 'description' = DESCRIPTION_TYPE;
export const ENVIRONMENT_FIELD_TYPE: 'environment' = ENVIRONMENT_TYPE;
export const JIRA_SERVICE_MANAGEMENT_APP_NAME = 'Jira Service Management';

// whitelisted custom field name
export const STORY_POINT_ESTIMATE_CF_NAME = 'Story point estimate' as const;
export const STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE = 'storyPointEstimate' as const;

export const PACKAGE_NAME = 'jiraProjectSettingsAppsCommon';

// Prefix to be used when generating an optimisticId for a new field option. This is to avoid collision with existing options.
export const NEW_FIELD_OPTION_PREFIX = 'NEW_';

// TODO: MCD-2089 revise these field types. These are not proper field types.
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const RADIO_FIELD_TYPE = 'radio' as const;
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const USERPICKER_FIELD_TYPE = 'userpicker' as const;
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const MULTIUSERPICKER_FIELD_TYPE = 'multiuserpicker' as const;
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const SELECT_FIELD_TYPE = 'select' as const;
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const CASCADINGSELECT_FIELD_TYPE = 'cascadingselect' as const;
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const MULTISELECT_FIELD_TYPE = 'multiselect' as const;
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const CHECKBOX_FIELD_TYPE = 'checkbox' as const;
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const TEXT_FIELD_TYPE = 'text' as const;
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const NUMBER_FIELD_TYPE = 'number' as const;
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const DATETIME_FIELD_TYPE = 'datetime' as const;
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const PROJECTPICKER_FIELD_TYPE = 'projectpicker' as const;
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const DATE_FIELD_TYPE = 'date' as const;
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const ASSETSPICKER_FIELD_TYPE = 'assetspicker' as const;
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const LABELPICKER_FIELD_TYPE = 'labelpicker' as const;
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const GROUPPICKER_FIELD_TYPE = 'grouppicker' as const;
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const MULTIGROUPPICKER_FIELD_TYPE = 'multigrouppicker' as const;
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const VERSION_FIELD_TYPE = 'version' as const;
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const MULTIVERSION_FIELD_TYPE = 'multiversion' as const;
/**
 * @deprecated instead import from '@atlassian/jira-platform-field-config'
 * This is not a valid custom field type string - it is some kind of modification or simplification.
 * I suspect for JSM portal or similar. It doesn't appear anywhere else in Jira.
 */
export const TEXTAREA_FIELD_TYPE = 'textarea' as const;
